import { render, staticRenderFns } from "./mob-basic.vue?vue&type=template&id=07b068b0&scoped=true"
import script from "./mob-basic.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-basic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob-basic.vue?vue&type=style&index=0&id=07b068b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b068b0",
  null
  
)

export default component.exports